export default __webpack_public_path__ + "static/media/akm-long-logo-black.1efe386c.svg";